import { render, staticRenderFns } from "./PatentResponsibleForm.vue?vue&type=template&id=0333066c&"
import script from "./PatentResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./PatentResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports